import face from './img/face.jpg';
import yd_twit from './img/yd_twit.png';
import yd_colo from './img/yd_colo.png';
import yd_mono from './img/yd_mono.png';
import SectionHeader from './components/SectionHeader'
import Snspace from './components/Snspace'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>YD 501 Media.</p>
      </header>
      <body className="App-body">

        <main className="App-main">

          <section className="section-hero">
            <h1>YD 501 Media.</h1>
          </section>

          <section className="section-about-me">

            <div className="section-header">
              <SectionHeader
                title="Profile."
              />
            </div>
            
            <div className="section-about-me-body">
              <article className="about-me">
                <img src={face} alt="face" className="about-me-face"/>
                <p> 
                  YDです。<br />
                  PythonやMATLABを使ってお仕事をしています。<br />
                  <br />
                  音楽、写真、なんでもござれ。<br />
                  <br />
                  <b>Python : </b>numpy, pandas, skimage, sklearn, re, matlplotlib, jupyterlab.<br />
                  <b>MATLAB : </b>MATLAB, App Designer.<br />
                  <br />
                  <b>Instrments : </b>Roland TD-17, Roland FA-08.<br />
                  <b>Camera : </b>FUJIFILM X-T20<br />
                  <b>Lens : </b>XF18-55, Helios44-2, Utulens.<br />
                </p>
              </article>
            </div>
          </section>

          <section className="section-sns">
            <div className="section-header">
              <SectionHeader
                title="SNS."
              />
            </div>
            <div className="section-sns-body">
              <Snspace
                title="Twitter"
                caption="Twitterのアカウント"
                discribe1="Twitter始めました。"
                discribe2="雑多につぶやきます。"
                src={yd_twit}
                alt="Twitter"
                href="https://www.twitter.com/yd501media/"
                text="@yd501media"
              />
              <Snspace
                title="Instagram"
                caption="カラー写真のアカウント"
                discribe1="カラー写真を投稿しています。"
                discribe2="人、モノ、風景、なんでも撮ります。"
                src={yd_colo}
                alt="Instagram-colo"
                href="https://www.instagram.com/yd_colo/"
                text="@yd_colo"
              />
              <Snspace
                title="Instagram"
                caption="モノクロ写真のアカウント"
                discribe1="『情報過多な時代に情報量を減らした写真』を"
                discribe2="コンセプトにしています。"
                src={yd_mono}
                alt="Instagram-mono"
                href="https://www.instagram.com/yd_mono/"
                text="@yd_mono"
              />
            </div>
          </section>
        </main>
      </body>
      {/* <footer className="App-footer">
      </footer> */}
    </div>
  );
}

export default App;
